import { supabaseIntegration } from "@supabase/sentry-js-integration";
import { SupabaseClient, User } from "@supabase/supabase-js";
import * as Sentry from "@sentry/react";

import { envVariables } from "../utils/envVariables";
import { routerInstance } from "../utils/router";

const isEnabled = envVariables.VITE_ENVIRONMENT !== "local";

export const initSentry = () => {
  Sentry.init({
    dsn: envVariables.VITE_SENTRY_DSN,
    environment: envVariables.VITE_ENVIRONMENT,
    integrations: [
      supabaseIntegration(SupabaseClient, Sentry, {
        tracing: true,
        breadcrumbs: true,
        errors: true,
      }),
      Sentry.tanstackRouterBrowserTracingIntegration(routerInstance),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
      }),
    ],
    enabled: isEnabled,
    // Session Replay
    replaysSessionSampleRate: 0, // Set to 0 to disable session replay
    replaysOnErrorSampleRate: isEnabled ? 1.0 : 0, // Capture all errors for session replay in non-local environments
  });
};

export const sendSentryMessage = (msg: string) => {
  Sentry.captureMessage(msg);
};

export const sendSentryError = ({
  error,
  message,
  shouldThrowError = true,
}: {
  error: unknown;
  message: string;
  shouldThrowError?: boolean;
}) => {
  Sentry.captureMessage(message, { extra: { error } });

  if (shouldThrowError) {
    if (typeof error === "string") {
      throw new Error(error);
    }

    throw new Error(message);
  }
};

export const setSentryUser = (user: User | null) => {
  Sentry.setUser(user);
};

export const addSentryBreadcrumb = ({
  category,
  message,
  data,
}: {
  category: string;
  message: string;
  data?: Record<string, unknown>;
}) => {
  Sentry.addBreadcrumb({
    category,
    message,
    data,
  });
};
